const useGetFaqCategoryListApi = async ({
  fetchOptions,
  options,
}: {
  fetchOptions?: MaybeRef<Omit<ApiRestOptions, "params"> & { params: FaqCategoryListQueryParams }>;
  options?: AsyncDataOptions<ApiRestResponse<ApiRestResult<FaqCategoryListResponse>>>;
} = {}) => {
  const { locale } = useI18n();

  const response = await useFetchRequest(async (defaultOptions) => {
    const mergedOptions = deepmerge(defaultOptions, unref(fetchOptions) || {});
    mergedOptions.params = {
      ...mergedOptions.params,
      locale: locale.value
    };
    return getFaqCategoryListApi(mergedOptions);
  }, options);

  const list = computed(() => {
    return response.data.value?.result?.data?.list ?? null;
  });

  return {
    ...response,
    list,
  };
};

export { useGetFaqCategoryListApi };
